import React, { useEffect, useState } from 'react';
import update from 'immutability-helper';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';

const ModalUserAccess = (props) => {
    const { arrPerm, toggle, isOpen, idAccessEdit, updateAccess, loading } = props;
    const [perm, setPerm] = useState(arrPerm)
    const [permissoes, setPermissoes] = useState([])
    const [loadingModal, setLoadingModal] = useState(true)

    const loadAccess = (e) => {
        e.forEach(item => {
            item.checked = verifyAccess(perm, item.idPermissao);
        },);
        setPerm(e)
    }

    const carregaLista = () => {
        const config = new Configurations();
        axios.get(config.apiBasePath + `/usuario/lista-permissoes`)
            .then(response => {
                setPermissoes(response.data.permissoes)
                loadAccess(response.data.permissoes);
            }).catch(err => {
            }).finally(() => {
                setLoadingModal(false)
            });
    }

    const verifyAccess = (prevPerm, numPerm) => {
        return perm.some(item => item === numPerm)
    }

    const handleCheckAccess = (e) => {
        const _index = permissoes.findIndex(item => item.idPermissao === parseInt(e.target.value, 10));
        setPermissoes(update(permissoes, { [_index]: { checked: { $set: !permissoes[_index].checked } } }))
    }


    useEffect(() => {
        setPerm(arrPerm)
    }, [arrPerm])

    useEffect(() => {
        if (isOpen === true) {
            carregaLista()
        }
    }, [isOpen])

    const newAccess = () => {
        updateAccess(idAccessEdit, permissoes);
        toggle();
    }

    const enableSave = () => {
        if (permissoes) return permissoes.filter(item => item.checked).length > 0
        else return false

    }

    return (
        <div className="row">
            <div className="col-12">
                <p>Selecione os níveis de acesso desejados:</p>
            </div>
            {!loadingModal ?
                <div className="col-12">
                    <div className="row d-flex">
                        <div className="col-6">
                            <h3 className='conteudo-title'>Conteúdo</h3>
                            <ul className='column-permissoes'>
                                {permissoes && permissoes.filter(i => i.idCategoriaAcesso === 4).map((item, index) => {
                                    return <div key={index} className="form-check">
                                        <input className="form-check-input" type="checkbox" name="access-level" id={`${item.idPermissao}`} checked={item.checked || item.checked === "true"} value={item.idPermissao} onChange={handleCheckAccess} />
                                        <label className="form-check-label" htmlFor="unitario"> {item.nome}: {item.descricao}</label>
                                    </div>
                                })}
                            </ul>
                        </div>

                        <div className="col-6">
                            <h3 className='operacoes-title'>Operações</h3>
                            <ul className='column-permissoes'>
                                {permissoes && permissoes.filter(i => i.idCategoriaAcesso === 3).map((item, index) => {
                                    return <div key={index} className="form-check">
                                        <input className="form-check-input" type="checkbox" name="access-level" id={`${item.idPermissao}`} checked={item.checked || item.checked === "true"} value={item.idPermissao} onChange={handleCheckAccess} />
                                        <label className="form-check-label" htmlFor="unitario"> {item.nome}: {item.descricao}</label>
                                    </div>
                                })}
                                {permissoes && permissoes.filter(i => i.idCategoriaAcesso === 8).map((item, index) => {
                                    return <div key={index} className="form-check">
                                        <input className="form-check-input" type="checkbox" name="access-level" id={`${item.idPermissao}`} checked={item.checked || item.checked === "true"} value={item.idPermissao} onChange={handleCheckAccess} />
                                        <label className="form-check-label" htmlFor="unitario"> {item.nome}: {item.descricao}</label>
                                    </div>
                                })}
                                {permissoes && permissoes.filter(i => i.idCategoriaAcesso === 9).map((item, index) => {
                                    return <div key={index} className="form-check">
                                        <input className="form-check-input" type="checkbox" name="access-level" id={`${item.idPermissao}`} checked={item.checked || item.checked === "true"} value={item.idPermissao} onChange={handleCheckAccess} />
                                        <label className="form-check-label" htmlFor="unitario"> {item.nome}: {item.descricao}</label>
                                    </div>
                                })}
                            </ul>
                            <ul className='column-permissoes'>
                                {permissoes && permissoes.filter(i => i.idCategoriaAcesso === 6).map((item, index) => {
                                    return <div key={index} className="form-check">
                                        <input className="form-check-input" type="checkbox" name="access-level" id={`${item.idPermissao}`} checked={item.checked || item.checked === "true"} value={item.idPermissao} onChange={handleCheckAccess} />
                                        <label className="form-check-label" htmlFor="unitario"> {item.nome}: {item.descricao}</label>
                                    </div>
                                })}
                                {permissoes && permissoes.filter(i => i.idCategoriaAcesso === 10).map((item, index) => {
                                    return <div key={index} className="form-check">
                                        <input className="form-check-input" type="checkbox" name="access-level" id={`${item.idPermissao}`} checked={item.checked || item.checked === "true"} value={item.idPermissao} onChange={handleCheckAccess} />
                                        <label className="form-check-label" htmlFor="unitario"> {item.nome}: {item.descricao}</label>
                                    </div>
                                })}
                            </ul>
                        </div>

                        <div className="col-6 pt-2">
                            <h3 className='cadastro-title'>Atendimento</h3>
                            <ul className='column-permissoes'>
                                {permissoes && permissoes.filter(i => i.idCategoriaAcesso === 7).map((item, index) => {
                                    return <div key={index} className="form-check">
                                        <input className="form-check-input" type="checkbox" name="access-level" id={`${item.idPermissao}`} checked={item.checked || item.checked === "true"} value={item.idPermissao} onChange={handleCheckAccess} />
                                        <label className="form-check-label" htmlFor="unitario"> {item.nome}: {item.descricao}</label>
                                    </div>
                                })}
                            </ul>
                            <ul className='column-permissoes'>
                                {permissoes && permissoes.filter(i => i.idCategoriaAcesso === 2).map((item, index) => {
                                    return <div key={index} className="form-check">
                                        <input className="form-check-input" type="checkbox" name="access-level" id={`${item.idPermissao}`} checked={item.checked || item.checked === "true"} value={item.idPermissao} onChange={handleCheckAccess} />
                                        <label className="form-check-label" htmlFor="unitario"> {item.nome}: {item.descricao}</label>
                                    </div>
                                })}
                            </ul>
                        </div>
                        <div className="col-6 pt-2">
                            <h3 className='admin-title'>Admin</h3>
                            <ul className='column-permissoes'>
                                {permissoes && permissoes.filter(i => i.idCategoriaAcesso === 1).map((item, index) => {
                                    return <div key={index} className="form-check">
                                        <input className="form-check-input" type="checkbox" name="access-level" id={`${item.idPermissao}`} checked={item.checked || item.checked === "true"} value={item.idPermissao} onChange={handleCheckAccess} />
                                        <label className="form-check-label" htmlFor="unitario"> {item.nome}: {item.descricao}</label>
                                    </div>
                                })}
                            </ul>
                        </div>

                        {/* <div className="col-12">
                        <ul>
                            {this.state.permissoes && this.state.permissoes.map((item, index) => {
                                return <div key={index} className="form-check">
                                    <input className="form-check-input" type="checkbox" name="access-level" id={`${item.key}`} checked={item.checked} value={item.idPermissao} onChange={this.handleCheckAccess} />
                                    <label className="form-check-label" htmlFor="unitario">{item.idPermissao} - {item.nome}: {item.descricao}</label>
                                </div>
                            })}
                        </ul>
                    </div> */}
                        <div className="col-12 border-top pt-3">
                            <div className="row text-center">
                                <div className="offset-3 col-3">
                                    {loading ? (
                                        <div className="spinner-border text-primary" role="status" />
                                    ) : (
                                        <button onClick={() => newAccess()} disabled={!enableSave()} className="btn btn-outline-success">salvar</button>
                                    )}
                                </div>
                                <div className="col-3">
                                    <button onClick={toggle} className="btn btn-outline-secondary">voltar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                : <div className='col-12 d-flex justify-content-center'>
                    <div className="spinner-border text-primary" role="status" />
                </div>
                }
        </div>
    );
}


export default ModalUserAccess;